import * as Constants from '../constants/action-constants';

import { AssetsApi, AuthApi } from 'vrlcm-gui-api';
import { RouteAccess, User } from 'vrlcm-gui-types';
import { all, call, put, takeLatest } from 'redux-saga/effects';

import { PageAction } from '../types/Common';
import { SettingGroup } from 'vrlcm-gui-types';
import SettingsMockAPI from '../api/settings/SettingsMockAPI';
import { getAuthorizedRoutes } from '../constants/SettingRouteConstants';
import produce from 'immer';
import { requestSettingsSuccess } from '../actions/Settings';

function* getSettingGroups() {
  const user: User = yield call(AuthApi.whoAmI);
  const groups: SettingGroup[] = yield call(SettingsMockAPI.getSettingGroups);
  const routeAccess: RouteAccess = yield call(AssetsApi.getRouteAccess);
  const filterAvailableGroups: SettingGroup[] = [];
  if (user) {
    const routes =
      routeAccess && getAuthorizedRoutes(user.authorities, routeAccess);
    groups.slice().forEach(group => {
      filterAvailableGroups.push(filterGroupActions(group, routes));
    });
  }
  yield put(requestSettingsSuccess(filterAvailableGroups));
}
function filterGroupActions(group: SettingGroup, routes: { [x: string]: any }) {
  return produce(group, draft => {
    draft.actions = group.actions.filter(
      (action: PageAction) =>
        action.action.route && routes && routes[action.action.route]
    );
  });
}

function* watchForSettingGroups() {
  yield takeLatest(Constants.REQUEST_SETTINGS, getSettingGroups);
}

export default function* dashboardSaga() {
  yield all([watchForSettingGroups()]);
}
